import type { TerrainParams } from "../terrain/height";

export interface WorldConfig {
  version: number;
  origin: { lat: number; lon: number };
  bounds: { min: [number, number]; max: [number, number] };
  zoneSize: number;
  terrain: TerrainParams & { colors: { grass: string; dirt: string; rock: string } };
  scenery: { treeDensity: number; rockDensity: number; exclusionRadius: number };
  landmarks: { id: string; type: string; pos: [number, number]; radius?: number; yaw?: number; size?: [number, number] }[];
  plots: { id: string; name: string; bounds: { min: [number, number]; max: [number, number] }; height: number }[];
  spawn: { pos: [number, number]; yaw: number };
  scriptEngineVersion: string;
}

export function zoneOf(x: number, z: number, size: number): { x: number; z: number } {
  return { x: Math.floor(x / size), z: Math.floor(z / size) };
}
